// fn-cart.js
(() => {
  const root = document.querySelector("[data-fn-cart]");
  if (!root) return;

  const moneyFormat =
    root.dataset.moneyFormat ||
    (window.Shopify && Shopify.money_format) ||
    "${{amount}}";
  const currency = root.dataset.currency || "USD";

  let busy = false;

  const formatMoney = (cents) => {
    const value = Number(cents) || 0;

    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(value, moneyFormat);
    }

    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency
      }).format(value / 100);
    } catch (err) {
      return `$${(value / 100).toFixed(2)}`;
    }
  };

  const setBusy = (state) => {
    busy = state;
    root.classList.toggle("is-loading", state);
  };

  const fetchCart = async () => {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed to fetch cart");
    return res.json();
  };

  const renderTotals = (cart) => {
    const total = formatMoney(cart.total_price);
    const subtotal = formatMoney(cart.items_subtotal_price);

    root.querySelectorAll("[data-total]").forEach((el) => {
      el.textContent = total;
    });

    root.querySelectorAll("[data-subtotal]").forEach((el) => {
      el.textContent = subtotal;
    });
  };

  const refreshTotals = async () => {
    try {
      const cart = await fetchCart();
      renderTotals(cart);
    } catch (err) {
      console.error(err);
    }
  };

  const changeLine = async (line, quantity) => {
    if (busy) return;
    setBusy(true);

    try {
      const res = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ line, quantity })
      });

      if (!res.ok) throw new Error("Failed to update line item");
      location.reload();
    } catch (err) {
      console.error(err);
      setBusy(false);
    }
  };

  const goCheckout = () => {
    if (busy) return;
    const code = root.querySelector("[data-discount]")?.value?.trim();
    location.href = code
      ? `/checkout?discount=${encodeURIComponent(code)}`
      : "/checkout";
  };

  root.addEventListener("click", (e) => {
    if (e.target.closest("[data-checkout]")) {
      e.preventDefault();
      goCheckout();
      return;
    }

    const row = e.target.closest(".fn-item");
    if (!row || busy) return;

    const line = Number(row.getAttribute("data-line"));
    if (!Number.isFinite(line)) return;

    if (e.target.closest("[data-remove]")) {
      e.preventDefault();
      changeLine(line, 0);
      return;
    }

    const stepBtn = e.target.closest("[data-qty]");
    if (!stepBtn) return;

    e.preventDefault();

    const input = row.querySelector("[data-qty-input]");
    const current = Math.max(0, parseInt(input?.value || "0", 10) || 0);
    const step = parseInt(stepBtn.getAttribute("data-qty") || "0", 10) || 0;
    const next = Math.max(0, current + step);

    changeLine(line, next);
  });

  root.addEventListener("change", (e) => {
    const input = e.target.closest("[data-qty-input]");
    if (!input || busy) return;

    const row = input.closest(".fn-item");
    if (!row) return;

    const line = Number(row.getAttribute("data-line"));
    if (!Number.isFinite(line)) return;

    const next = Math.max(0, parseInt(input.value || "0", 10) || 0);
    changeLine(line, next);
  });

  root.querySelector("[data-discount]")?.addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      goCheckout();
    }
  });

  root.querySelector("[data-apply]")?.addEventListener("click", (e) => {
    e.preventDefault();
    goCheckout();
  });

  refreshTotals();
})();
